import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

import { getToken } from '@verantos-dev/core-auth';

const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;
type BaseApiOptions = {
  version?: string;
  overrideBaseUrl?: string;
};

export const createBaseQuery = ({
  version = 'v1',
  overrideBaseUrl = BASE_API_URL,
}: BaseApiOptions): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =>
  fetchBaseQuery({
    baseUrl: `${overrideBaseUrl}/${version}`,
    prepareHeaders: async (headers) => {
      const token = await getToken();
      headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  });
